import React, {useState} from 'react';
import {IconButton, Popover, Typography, Box} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface HelpPopoverProps {
    content: React.ReactNode;
    color?: string;
    style?: React.CSSProperties;
    customIcon?: React.ReactNode;
}

const HelpPopover = ({content, color, style, customIcon}: HelpPopoverProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton size="small" onClick={handleClick} sx={{...style, ml: 0.5, verticalAlign: 'middle'}}>
                {customIcon ? customIcon : (<HelpOutlineIcon fontSize="small" sx={{color: color}} />)}
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box p={2} maxWidth={300}>
                    <Typography variant="body2" component="div">
                        {content}
                    </Typography>
                </Box>
            </Popover>
        </>
    );
};

export default HelpPopover;
